<template>
	<div class="bg">
		<div class='content'>
			<div class="content-header">
				<div class="content-header-tle">
					{{commonTopData.pageName}}
				</div>
				<div class="content-header-btn">
					<ul>
						<li v-for="(item,index) in commonTopData.commonleftbtn" :key="index" @click="getparent(item)"><img :src="item.img" alt="" class="content-header-img">{{item.name}}</li>
					</ul>
				</div>
			</div>
			<div class="content-table">
				<el-table
                    v-if="tableConfig.ischeck"
					:data="tableData"
					:reserve-selection="true" 
					:row-key="getRowKeys"
					tooltip-effect
					style="width: 100%"
					@selection-change="selectDialog"         
					height="500"
					ref="multipleTable">
					<el-table-column width="55" type="selection" v-if="tableConfig.ischeck"></el-table-column>
					<el-table-column v-for="(item, index) in tableConfig.list" :key="index" :prop="item.prop" :label="item.label" :sortable="item.type == 'sort'">
						<template slot-scope="scope">
							<img class="avatar-img" v-if="item.type == 'img'" :src="scope.row[item.prop]" alt="" @click="getimgulr(scope.row[item.prop])">
							<span v-if="item.type == 'keyvalue'"><span>{{ item.child[scope.row[item.prop]] ? item.child[scope.row[item.prop]] : item.child.no }}</span></span>
							<span v-if="item.type == undefined">{{ scope.row[item.prop] }}</span>
						</template>
					</el-table-column>
				</el-table>
                <el-table
                    v-else
					:data="tableData"
					:reserve-selection="true" 
					:row-key="getRowKeys"
					tooltip-effect
					style="width: 100%"
					highlight-current-row
					@current-change="selectCurrentChange"          
					height="500"
					ref="singleTable">
					<el-table-column width="55" type="selection" v-if="tableConfig.ischeck"></el-table-column>
					<el-table-column v-for="(item, index) in tableConfig.list" :key="index" :prop="item.prop" :label="item.label" :sortable="item.type == 'sort'">
						<template slot-scope="scope">
							<img class="avatar-img" v-if="item.type == 'img'" :src="scope.row[item.prop]" alt="" @click="getimgulr(scope.row[item.prop])">
							<span v-if="item.type == 'keyvalue'"><span>{{ item.child[scope.row[item.prop]] ? item.child[scope.row[item.prop]] : item.child.no }}</span></span>
							<span v-if="item.type == undefined">{{ scope.row[item.prop] }}</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="content-block">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:current-page="currentPage"
						:page-sizes="sizes"
						:page-size="pagesize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>
			<div class='sel_btn'>
				<el-button @click='qx()'>关闭</el-button>
				<el-button type="primary" :loading="loadSure" @click='ADDlist()'>确定{{tableConfig.ischeck?'('+multipleSelection.length+')':''}}</el-button>	
			</div>
            <el-drawer :wrapperClosable="false" title="筛选" width="200" :visible.sync="filterDrawer" @closeDrawer="closeFilterDrawer('filterDrawer')">
                <div class="p-filter-content-wrap">
                    <el-form class="p-filter-content" label-position="top">
                        <el-form-item v-for="(item,index) in filterFields.filterFields" :key="index" :label="item.name">
                            <el-select placeholder="请选择" v-if="item.type == 'select'" v-model="filter[item.id]">
                                <el-option
                                    v-for="da in item.child"
                                    :key="da.value"
                                    :label="da.label"
                                    :value="da.value">
                                </el-option>
                            </el-select>
                            <el-input v-else v-model="filter[item.id]" placeholder="请输入要搜索的奖品名称"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="p-btns">
                        <el-button @click="clearFilter('filterDrawer')">清空</el-button>
                        <el-button type="primary" @click="searchClick('filterDrawer')">确定</el-button>
                    </div>
                </div>
            </el-drawer>
            <el-drawer :wrapperClosable="false" :title="commonTopData.pageName+'-展示字段筛选'" width="200" :visible.sync="drawer" @closeDrawer="closeFilterDrawer('drawer')">
                <div class="p-filter-content-wrap">
                    <div class="screenMidden paddinglr30">
                        <el-checkbox-group class="screenMiddenShowul" v-model="selectbtns">
                            <el-checkbox class="checkboxshow" v-for="(item,index) in defaultsList" :label="item.prop" :key="index" border>{{item.label}}</el-checkbox>
                            <button class="defaultbtn"></button>
                        </el-checkbox-group>
                    </div>
                    <div class="p-btns">
                        <el-button @click="clearFilter('drawer')">恢复默认</el-button>
                        <el-button type="primary" @click="searchClick('drawer')">确定</el-button>
                    </div>
                </div>
            </el-drawer>
		</div>
		<div class="maskimg screenContent" v-if="isimgurl" @click="getimgulr">
			<img :src="imgurl" alt="暂无图片" class="cover-img">
		</div>
        
	</div> 
</template>
<script>
export default {
	props:['commonTopData', 'tableConfig', 'filterFields', 'defaults'],
	name: "tant",
	data(){
		return {
			loading: false,
			loadSure:false,
			tableData:[],
			sizes:[100, 200, 300, 400],
			currentPage:1,
			pagesize: 100,
			total:0,
			isimgurl:false,
			imgurl:'',
			currentRow: {},
			multipleSelection: [],
            filterDrawer: false,
            filter: {},
            drawer: false,
            selectbtns: [],
            defaultsList: [],
			multipleSelectionAll: [],
			pageid: '',
			radio: '',
			row: {},
		}
	},
	watch:{
		

	},
	methods: {
        getScreen() {
            this.defaultsList = this.tableConfig.list;
        },
		selectDialog(val) {
			this.multipleSelectionAll=[];
			this.multipleSelection = val;
			this.changePageCoreRecordData(this.multipleSelection)
		},
		changePageCoreRecordData (x) {
			// 总选择里面的key集合
			let selectAllIds = [];
			
			this.multipleSelectionAll.forEach((row)=>{
				selectAllIds.push(row.open_id);	
			})
			
			let selectIds = [];
			// 获取当前页选中的id
			x.forEach((row)=>{
				selectIds.push(row.open_id);
				if (selectAllIds.indexOf(row.open_id) < 0) {
					this.multipleSelectionAll.push(row);
				}
			});
			
			let pageids = [];
			let noSelectIds = [];
			this.tableData.forEach((row)=>{
				pageids.push(row.open_id);
				if (selectIds.indexOf(row.open_id) < 0) {
					noSelectIds.push(row.open_id);
				}
			})
			noSelectIds.forEach(id=>{
				if (selectAllIds.indexOf(id) >= 0) {
					for(let i = 0; i< this.multipleSelectionAll.length; i ++) {
						if (this.multipleSelectionAll[i].open_id == id) {
							// 如果总选择中有未被选中的，那么就删除这条
							this.multipleSelectionAll.splice(i, 1);
						}
					}
				}
			})
			
			this.selected = this.multipleSelectionAll.length;
			
			if(this.$parent.dataList){
				this.$parent.dataList = this.multipleSelectionAll;
			}
			if(this.$parent.$parent.dataList){
				this.$parent.$parent.dataList = this.multipleSelectionAll;
			}
			
			
			
		},
		change(data){	
			this.$refs.multipleTable.clearSelection();
			this.changePageCoreRecordData (data)
			let _this = this
			for(let i = 0;i<data.length;i++){
				var c = i
				for(let x = 0;x<this.multipleSelectionAll.length;x++){ 			    
					if(data[i].open_id == this.multipleSelectionAll[x].open_id ){
						var f = function(a){
							setTimeout(() => {
								_this.$refs.multipleTable.toggleRowSelection(data[a],true);
							}, 100);
						}
						f(c)
					}
				}
			}
			
		},
		ADDlist() {
			if(this.tableConfig.ischeck){
				this.$emit('ADDlist',this.multipleSelection)
			}else{
				this.$emit('ADDlist',this.currentRow)
			}	
		},
		qx() {
			this.$emit('hide')
		},
		handleSizeChange(val) {
			this.pagesize = val;
			this.getTabData();
		},
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getTabData();
		},
		getparent(row) {
            if(row.fun == 'ISshow'){
                this.filterDrawer = true;
            }
			if(row.fun == 'ISfield'){
                this.drawer = true;
                this.initbts()
            }
		},
		getTabData() {
			this.loading = true;
			let data = {};
			data = {
				access_token: localStorage.getItem("access_token"),
				page: this.currentPage,
				limit:this.pagesize,
			}
			//获取筛选的条件
			if (this.filter) {
				const sreenData = this.filter
				sreenData.page = this.currentPage;
				sreenData.limit = this.pagesize;
				sreenData.access_token = localStorage.getItem("access_token");
				data = sreenData;
			}
			let url = this.tableConfig.url;
			this.api[url](data).then((da) => {
				this.tableData = da.data;
				this.total = da.total;
				this.loading = false;
			}).catch((err) => {
				console.log(err)
				this.loading = false;
			});
		},
		getimgulr(url) {
			this.imgurl = url;
			this.isimgurl = !this.isimgurl
		},
		getRowKeys(row) {
			this.row = row;
			this.radio = row.open_id;
		},
		selectCurrentChange(val) {
			this.currentRow = val;
		},
        closeFilterDrawer(data) {
            this[data] = false
        },
        searchClick(data) {
            if(data == 'filterDrawer'){
                this.currentPage = 1
                this.getTabData();
                this.filterDrawer = false
            }  
            if(data == 'drawer'){
                this.$emit('isShowBtn',this.selectbtns,this.defaultsList);
                this.drawer = false;
            }
        },
        clearFilter(data) {
            if(data == 'filterDrawer'){
                this.filter = {}
            }
        },
        initbts() {
            this.selectbtns = [];
            this.defaults.forEach(item => {
                this.selectbtns.push(item)
            })
        }
	},
	created(){
		this.getTabData();
        this.getScreen();
	},
	mounted() {
		
	}
}
</script>
<style scoped>
    .bg{
        position: fixed;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.3);
		z-index: 2021;
    }
    .content{
        width: 1326px;
		min-height: 700px;
        max-height:767px;
        position: absolute;
        top:46%;
        left: 50%;
        transform: translate(-50%,-50%);
		background: #fff;
    }
	.content-header{
		padding: 24px;
	}
	.content-header-tle{
		width: 30%;
		float: left;
	}
	.content-header-btn{
		width: 60%;
		float: right;
		text-align: right;
	}
	.content-header-btn > ul > li{
		width: 100px;
		color: #999;
		text-align: center;
		cursor: pointer;
		display: inline-block;
		margin: 0 10px 0 0;
	}
	.content-table{
		padding: 24px 24px 0 24px;
	}
	.content-header-img{
		margin-right:3px;
		position: relative;
		top:1px;
	}
    .sel_btn{
		width: 100%;
		height: 50px;
		text-align: center;
		line-height: 50px;
		position: fixed;
		bottom: 0;
		border-top: 1px solid #606266;
    }
	.avatar-img{
		width: 50px;
		height: 50px;
		border-radius: 50%;
		margin: auto;
		display: block;
	}
	.maskimg{
		position: fixed;
		top:0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0,0,0,0.5);
		z-index: 2005;
	}
	.cover-img{
		max-height:500px;
	}
    .p-filter-content-wrap{
        padding: 0 20px 50px 20px;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    .p-filter-content{
        flex: 1;
    }
    .p-btns{
        text-align: center;
        padding-bottom: 20px;
    } 
    .bg >>> .el-drawer{
        position: absolute;
        right: 0;
    }
    .bg >>> .el-drawer__body{
        overflow-y: scroll;
    } 
    .screenbordershow{
		width: 380px;
		background: #FFFFFF;
		border-radius: 5px;
		position: absolute;
		right: 335px;
		top: 110px;
		overflow-y: scroll;
        height: calc(100% - 127px);
	}
	
	.screenMiddenShowul{
		padding-top:30px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		justify-content: space-between;
		flex-flow: row wrap; 
	}
    .screenMidden{
        padding-bottom: 50px;
    }
	
	.checkboxshow{
		height: 56px;
		margin: 0;
		margin-bottom: 20px;
	}
	
	.el-checkbox.is-bordered.is-checked{
		border: none !important;
		float: left;
        width: 47%;
		margin-left: 0 !important;
	}
	
	.el-checkbox.is-bordered{
		border: none !important;
		float: left;
        width: 47%;
		margin-left: 0 !important;
	}
	
	.el-checkbox__input.is-focus .el-checkbox__inner{
		border-color: #DCDFE6 !important;
	}
	
	.el-checkbox{
		margin-right: 0 !important;
	}
	.screenBottom{
		width: 380px;
		position: fixed;
		bottom: 1.8%;
		padding: 0;
		background: #FFFFFF;
		z-index: 999999;
	}
    .defaultbtn{
        visibility: hidden;
        width: 193px;
    }
</style>
